import React from "react";
import { Droplet } from "react-feather";
import { ReactComponent as RightArrow } from "../assets/icons/rightArrow.svg";

const Footer = () => {
  return (
    <div className="bg-white pt-4 px-4 pb-5 text-gray-600">
      <div className="lg:flex lg:px-4">
        <div className="pt-4 leading-loose lg:w-1/2 max-w-6xl">
          <h1 className="font-semibold tracking-wide inline-block mr-2">
            Hornet Vision
          </h1>
          <Droplet className="h-6 w-6 fill-current text-sac inline-block" />
          <h1 className="text-sm">
            Tell us your events, we will put it on the map. Find events near you
            using our AR app.
          </h1>
          <div className="pt-1 pb-2">
            <a
              href="https://www.apple.com/ios/app-store/"
              className="text-sac text-bold hover:text-sac-darker"
            >
              Download app
              <RightArrow className="h-4 w-4 inline-block fill-current" />
            </a>
          </div>
        </div>
        <div className="leading-loose pt-1 lg:pt-4 lg:w-1/2">
          <h1 className="font-semibold tracking-wide">Created by </h1>
          <div className="text-sm grid grid-cols-2">
            <h1>Kevin Pacheco</h1> <h1>Nhan Pham</h1> <h1>Quinlan Padgham</h1>
            <h1>Victoria Margaryan</h1> <h1>Dat Hua</h1>
            <h1>Jason Wong</h1>
          </div>
        </div>
      </div>
      <h1 className="text-center pt-4 pb-6 text-sm">
        © 2020, All rights reserved to Hornet Vision
      </h1>
    </div>
  );
};

export default Footer;
